import React, { Dispatch, useEffect } from "react";
import { DatePicker, Row } from "antd";
import moment, { Moment } from "moment";
import locale from 'antd/es/date-picker/locale/fr_FR';

const DATE_FORMAT = 'DD/MM/YYYY';

interface Props {
  setRange: Dispatch<{ start: Moment, end: Moment }>
  range: { start: Moment, end: Moment }
}

const DateRange = ({ setRange, range }: Props) => {

  const { RangePicker } = DatePicker;

  useEffect(() => {
    defaultDate()
  }, [])

  const defaultDate = () => {
    const current = moment(new Date()).hour(23).minute(59)
    setRange({ start: moment(current.clone().subtract(1, "month").hour(0).minute(0)), end: current })
  }

  const handleDate = (date: any) => {
    if (!date) {
      defaultDate()
    } else {
      setRange({ start: date[0], end: date[1] })
    }
  }

  return (
    <Row style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
      <span style={{ fontSize: "1.2rem" }}>Période:</span>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        <RangePicker
          defaultValue={[moment('2015/01/01', DATE_FORMAT), moment('2015/01/01', DATE_FORMAT)]}
          value={[range.start, range.end]}
          locale={locale}
          format={DATE_FORMAT}
          onChange={(elem) => handleDate(elem)}
        />
      </div>
    </Row>
  )
}

export default DateRange